export enum PermanentDeviceSettingsEditMode {
  Admin = 'admin',
  User = 'user',
  None = 'none',
}
export const PermanentDeviceSettingsEditModePath = 'administrate-device-mode';
